/* Care Philosophy — scroll reveal + meter fill. IIFE, reduced-motion safe. */
(function () {
  'use strict';

  var roots = document.querySelectorAll('.pnh-phil');
  if (!roots.length) return;

  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Animate the foam-vs-clean meters from zero on reveal.
  function primeMeters(root) {
    var fills = root.querySelectorAll('.pnh-phil__meter-fill');
    for (var i = 0; i < fills.length; i++) {
      var fill = fills[i];
      var target = fill.getAttribute('style') || '';
      fill.setAttribute('data-target', target);
      if (!prefersReduced) fill.style.transform = 'scaleX(0)';
    }
  }
  function fillMeters(root) {
    if (prefersReduced) return;
    var fills = root.querySelectorAll('.pnh-phil__meter-fill');
    for (var i = 0; i < fills.length; i++) {
      (function (fill, delay) {
        var target = fill.getAttribute('data-target');
        if (!target) return;
        fill.style.transition = 'transform 1.1s cubic-bezier(0.25,0.46,0.45,0.94) ' + delay + 's';
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () { fill.setAttribute('style', target + ';transition:transform 1.1s cubic-bezier(0.25,0.46,0.45,0.94) ' + delay + 's;'); });
        });
      })(fills[i], i * 0.18);
    }
  }

  var revealEls = document.querySelectorAll('.pnh-phil .js-reveal');
  function revealAll() {
    for (var i = 0; i < revealEls.length; i++) revealEls[i].classList.add('is-visible');
    for (var k = 0; k < roots.length; k++) fillMeters(roots[k]);
  }

  // Fail-safe: reveals are .js-gated, so never let an error leave content hidden.
  try {
    for (var r = 0; r < roots.length; r++) primeMeters(roots[r]);

    if (prefersReduced || !('IntersectionObserver' in window)) {
      revealAll();
    } else {
      var observer = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          if (entry.target.querySelector && entry.target.querySelector('.pnh-phil__meter-fill')) {
            fillMeters(entry.target);
          }
          obs.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      for (var m = 0; m < revealEls.length; m++) observer.observe(revealEls[m]);
    }
  } catch (e) {
    revealAll();
  }

  // Copy-link (clipboard API with execCommand fallback)
  var copyBtns = document.querySelectorAll('.pnh-phil [data-pnh-copy]');
  function flagCopied(btn) {
    var label = btn.querySelector('[data-pnh-copy-label]');
    var prev = label ? label.textContent : '';
    btn.classList.add('is-copied');
    if (label) label.textContent = (window.PNH_I18N && window.PNH_I18N.copied) || 'Copied';
    window.setTimeout(function () {
      btn.classList.remove('is-copied');
      if (label) label.textContent = prev || 'Copy link';
    }, 1800);
  }
  for (var c = 0; c < copyBtns.length; c++) {
    copyBtns[c].addEventListener('click', function () {
      var btn = this;
      var url = btn.getAttribute('data-pnh-copy') || '';
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () { flagCopied(btn); }).catch(function () { fallbackCopy(url, btn); });
      } else {
        fallbackCopy(url, btn);
      }
    });
  }
  function fallbackCopy(text, btn) {
    try {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'absolute';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      flagCopied(btn);
    } catch (e) { /* no-op */ }
  }
})();
